'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

export function LoggedOutBanner() {
  const pathname = usePathname()
  const href =
    pathname && pathname !== '/signup'
      ? `/signup?next=${encodeURIComponent(pathname)}`
      : '/signup'

  return (
    <Link
      href={href}
      prefetch={false}
      className="flex h-10 shrink-0 items-center justify-center bg-accent-600 px-4 text-center text-sm font-medium text-white transition-colors hover:bg-accent-700 relative z-0"
    >
      You&apos;re viewing example data. Sign up to connect your channels and see your real campaigns.
    </Link>
  )
}
